import { BooleanValues } from "constants/global";

const { TRUE, FALSE, ON, OFF } = BooleanValues;

export const goToTop = (id: string | null) => {
	const element = id ? document.getElementById(id) : null;
	const paddingNav = !id ? 0 : window.innerWidth >= 992 ? 90 : 180;
	const y = element ? element.getBoundingClientRect().top + window.scrollY : 0;
	window.scroll({
		top: y - paddingNav,
		behavior: "smooth",
	});
};

export const convertBooleanToSwitch = (value: string | undefined) => {
	switch (value) {
		case TRUE:
			return ON;
		case FALSE:
			return OFF;
		default:
			return value;
	}
};

export const convertSwitchToBoolean = (value: string | undefined) => {
	switch (value) {
		case ON:
			return TRUE;
		case OFF:
			return FALSE;
		default:
			return value;
	}
};

export const CFValidator = (value: string | undefined) => {
	const reg = /^[A-Za-z]{6}\d{2}[A-Za-z]{1}\d{2}[A-Za-z]\d{3}[A-Za-z]$/;

	if (!value) return true;

	return reg.test(value);
};

export const getTitolareStatusClass = (titolare: any) => {
	if (titolare.fullfiled || titolare.fulfilled) return "-green";
	if (titolare.invitationRequest) return "-yellow";
	if (titolare.rejected) return "-red";
	return "";
};

export const getStatusTitolare = (titolare: any): string => {
	// ambiguità tra i nomi
	if (titolare.fullfiled || titolare.fulfilled) return "Compilato";
	if (titolare.invitationRequest) return "Invito inoltrato";
	if (titolare.rejected) return "Non è più titolare";
	return "Da compilare";
};
